import { render, staticRenderFns } from "./CategorieComponent.vue?vue&type=template&id=2bd0d558"
import script from "./CategorieComponent.vue?vue&type=script&lang=js"
export * from "./CategorieComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports